import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import { Reveal } from "@/components/site/Reveal";
import { usePageMeta } from "@/lib/seo";

const SECTIONS = [
  {
    t: "1. Responsable du traitement",
    p: [
      "Le responsable du traitement est :",
      "ASAP Technologies – SARL\n231 rue Saint-Honoré\n75001 Paris\nSIRET : 907 820 575 00021",
      "Pour toute question relative à la protection de vos données personnelles ou pour exercer vos droits, vous pouvez nous contacter à l'adresse suivante : privacy@asaptech.fr",
    ],
  },
  {
    t: "2. Données collectées",
    p: [
      "Selon les informations demandées dans le formulaire, nous pouvons notamment collecter : vos nom et prénom ; votre adresse e-mail professionnelle ; votre fonction ; le nom de votre entreprise ; éventuellement votre numéro de téléphone ; toute information que vous choisissez volontairement de nous transmettre.",
      "Les champs obligatoires sont identifiés comme tels dans le formulaire. Leur renseignement est nécessaire pour pouvoir traiter votre demande et vous transmettre le contenu demandé.",
      "Nous vous invitons à ne pas nous communiquer de données sensibles ou d'informations relatives à des tiers qui ne seraient pas nécessaires à votre demande.",
    ],
  },
  {
    t: "3. Finalités et bases légales",
    p: [
      "Vos données personnelles peuvent être utilisées pour les finalités suivantes :",
      "Traitement de votre demande et transmission du livre blanc — Vos données sont utilisées afin de répondre à votre demande et de vous transmettre le contenu sollicité. Base légale : traitement nécessaire à l'exécution de votre demande.",
      "Réponse à vos questions et suivi de votre demande — Nous pouvons utiliser vos coordonnées afin d'échanger avec vous concernant votre demande ou votre intérêt pour nos contenus et services. Base légale : notre intérêt légitime à répondre aux demandes reçues et à assurer leur suivi.",
      "Prospection commerciale auprès de professionnels — Lorsque cela est pertinent au regard de votre activité professionnelle, ASAP Technologies peut utiliser vos coordonnées professionnelles pour vous présenter ses expertises, contenus, événements ou offres de services susceptibles de vous intéresser, notamment dans le domaine de l'Agilité et des services numériques. Base légale : notre intérêt légitime à développer notre activité commerciale auprès de professionnels. Vous pouvez vous opposer à tout moment et gratuitement à l'utilisation de vos données à cette fin, notamment en utilisant le lien de désabonnement présent dans nos communications ou en nous contactant à l'adresse indiquée à l'article 1.",
      "Mesure d'audience et amélioration du site — Certaines données techniques peuvent être utilisées afin de mesurer l'audience de cette page, analyser son utilisation et améliorer son fonctionnement. Selon les outils utilisés et leur configuration, ces traitements peuvent reposer sur notre intérêt légitime lorsqu'ils bénéficient d'une exemption de consentement ou sur votre consentement lorsqu'un consentement préalable est requis.",
    ],
  },
  {
    t: "4. Communications commerciales",
    p: [
      "ASAP Technologies s'adresse principalement à une clientèle professionnelle.",
      "Lorsque votre adresse électronique professionnelle est utilisée pour vous adresser des communications commerciales en rapport avec votre activité professionnelle, ce traitement repose sur notre intérêt légitime à promouvoir nos services auprès de professionnels.",
      "Vous êtes informé de cette utilisation lors de la collecte de vos données et pouvez vous y opposer simplement et gratuitement, au moment de la collecte ou ultérieurement.",
      "Chaque communication électronique commerciale comporte un moyen simple permettant de vous désabonner ou de vous opposer à de nouvelles sollicitations.",
      "Lorsque la réglementation impose votre consentement préalable, notamment dans certaines situations concernant des particuliers, aucun message commercial ne vous sera adressé sans votre accord préalable.",
    ],
  },
  {
    t: "5. Destinataires des données",
    p: [
      "Vos données personnelles peuvent être accessibles : aux collaborateurs habilités d'ASAP Technologies ayant besoin d'y accéder dans le cadre de leurs fonctions ; aux prestataires techniques intervenant pour notre compte, notamment pour l'hébergement du site, la gestion du formulaire, le stockage et la gestion des contacts, l'envoi d'e-mails ou la mesure d'audience.",
      "Ces prestataires n'accèdent aux données que dans la mesure nécessaire à l'exécution de leurs prestations et sont tenus de respecter les obligations applicables en matière de protection des données personnelles.",
      "ASAP Technologies ne vend ni ne loue vos données personnelles à des tiers.",
      "Lorsque certains prestataires sont susceptibles de traiter des données en dehors de l'Espace économique européen, nous veillons à ce que ces transferts soient encadrés conformément à la réglementation applicable, notamment au moyen d'une décision d'adéquation de la Commission européenne ou de garanties appropriées telles que les clauses contractuelles types de la Commission européenne.",
    ],
  },
  {
    t: "6. Durée de conservation",
    p: [
      "Vos données sont conservées uniquement pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées. À titre indicatif :",
      "• Données nécessaires au traitement de votre demande : pendant la durée nécessaire au traitement de celle-ci puis, le cas échéant, pendant la durée nécessaire à la gestion de la relation avec vous ;",
      "• Données utilisées à des fins de prospection commerciale : trois ans à compter de leur collecte ou du dernier contact émanant de votre part ;",
      "• Données permettant de prendre en compte une opposition ou un désabonnement : les données strictement nécessaires peuvent être conservées afin de respecter durablement votre choix ;",
      "• Données issues des outils de mesure d'audience : pendant les durées correspondant à la configuration et aux finalités des outils concernés, dans les limites prévues par la réglementation applicable.",
      "À l'issue de ces périodes, les données sont supprimées, anonymisées ou, lorsqu'une obligation légale ou la nécessité de défendre nos droits le justifie, archivées pendant la durée nécessaire.",
    ],
  },
  {
    t: "7. Vos droits",
    p: [
      "Conformément à la réglementation applicable en matière de protection des données personnelles, vous disposez, selon les traitements concernés : d'un droit d'accès à vos données ; d'un droit de rectification ; d'un droit à l'effacement ; d'un droit à la limitation du traitement ; d'un droit d'opposition, notamment à l'utilisation de vos données à des fins de prospection commerciale ; d'un droit à la portabilité de vos données lorsque celui-ci est applicable ; du droit de retirer votre consentement à tout moment lorsqu'un traitement repose sur celui-ci.",
      "Pour exercer vos droits, vous pouvez nous contacter à : privacy@asaptech.fr",
      "Nous pourrons être amenés à vous demander des informations complémentaires lorsque celles-ci sont nécessaires afin de vérifier votre identité.",
      "Vous pouvez également vous désabonner de nos communications commerciales à tout moment en utilisant le lien prévu à cet effet dans chaque e-mail.",
      "Si, après nous avoir contactés, vous estimez que vos droits ne sont pas respectés, vous disposez du droit d'introduire une réclamation auprès de la Commission nationale de l'informatique et des libertés (CNIL).",
    ],
  },
  {
    t: "8. Cookies et autres traceurs",
    p: [
      "Cette page peut utiliser des cookies et autres traceurs nécessaires à son fonctionnement ainsi que des outils permettant de mesurer son audience.",
      "Les traceurs strictement nécessaires au fonctionnement du site ou répondant aux conditions d'exemption prévues par la réglementation peuvent être utilisés sans consentement préalable.",
      "Les autres traceurs, notamment lorsqu'ils permettent un suivi publicitaire, une analyse non exemptée de consentement ou un partage de données avec des tiers, ne sont déposés qu'après avoir recueilli votre consentement lorsqu'il est requis.",
      "Vous pouvez modifier vos choix relatifs aux cookies à tout moment à partir de l'outil de gestion des cookies disponible sur le site, lorsqu'un tel outil est nécessaire.",
    ],
  },
  {
    t: "9. Sécurité",
    p: [
      "ASAP Technologies met en œuvre des mesures techniques et organisationnelles appropriées afin de protéger les données personnelles contre la destruction, la perte, l'altération, la divulgation ou l'accès non autorisé.",
      "L'accès aux données personnelles est limité aux personnes et prestataires ayant besoin d'en connaître dans le cadre de leurs missions.",
    ],
  },
  {
    t: "10. Modification de la politique",
    p: [
      "La présente politique peut être modifiée afin de tenir compte de l'évolution de nos traitements, de nos outils ou de la réglementation.",
      "La version applicable est celle publiée sur cette page et portant la date de dernière mise à jour indiquée en tête du document.",
    ],
  },
];

export default function PrivacyPage() {
  usePageMeta(
    "Politique de confidentialité",
    "Politique de confidentialité d'ASAP Technologies : collecte et traitement de vos données personnelles."
  );

  return (
    <main className="bg-[#0b0f19] min-h-screen" data-testid="privacy-page">
      <Nav />
      <section className="pt-32 pb-20 md:pt-40">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="font-mono2 text-[11px] tracking-[0.25em] uppercase grad-text">Mentions légales</div>
            <h1 className="mt-4 font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-slate-50">
              Politique de confidentialité
            </h1>
            <p className="mt-3 text-xs text-slate-500 font-mono2">Dernière mise à jour : 25 septembre 2026</p>
            <p className="mt-6 text-sm text-slate-400 leading-relaxed">
              La présente politique explique comment ASAP Technologies collecte et traite vos données personnelles
              lorsque vous consultez cette page, remplissez notre formulaire ou demandez à recevoir notre livre blanc
              consacré à l'Agilité.
            </p>
          </Reveal>

          <div className="mt-12 space-y-10">
            {SECTIONS.map((s, i) => (
              <Reveal key={i} delay={Math.min(i * 0.03, 0.2)}>
                <div data-testid={`privacy-section-${i + 1}`}>
                  <h2 className="font-heading text-lg font-semibold text-slate-100">{s.t}</h2>
                  <div className="mt-3 space-y-3">
                    {s.p.map((para, j) => (
                      <p key={j} className="text-sm text-slate-400 leading-relaxed whitespace-pre-line">
                        {para}
                      </p>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
